// @flow
export const arrayContainsSameItem = (arr1: Array, arr2: Array) => {
  let found = false;
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) > -1) {
      found = true;
      break;
    }
  }
  return found;
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/lib/array.js